/* Reveal animations */
var rvObs = new IntersectionObserver(function(es) {
  es.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('on'); rvObs.unobserve(e.target); }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
document.querySelectorAll('.rv').forEach(function(el) { rvObs.observe(el); });

/* Counters — animation easing cubic */
function countUp(el, dur) {
  dur = dur || 1600;
  var t = parseFloat(el.dataset.target);
  var suf = el.dataset.suffix || '';
  var s = performance.now();
  (function f(n) {
    var p = Math.min((n - s) / dur, 1);
    var v = t * (1 - Math.pow(1 - p, 3));
    el.textContent = Math.round(v) + suf;
    if (p < 1) requestAnimationFrame(f);
    else el.textContent = t + suf;
  })(s);
}
var counted = false;
new IntersectionObserver(function(es) {
  es.forEach(function(e) {
    if (e.isIntersecting && !counted) {
      counted = true;
      e.target.querySelectorAll('.counter').forEach(function(el) { countUp(el); });
    }
  });
}, { threshold: 0.3 }).observe(document.querySelector('.stats-band'));

function toggleMore(btn) {
  var mores = btn.parentElement.querySelectorAll('.team-card-more');
  var isOpen = btn.classList.contains('open');
  mores.forEach(function(el) { el.style.display = isOpen ? 'none' : 'block'; });
  btn.classList.toggle('open', !isOpen);
  btn.innerHTML = isOpen
    ? 'Voir plus <i class="ti ti-chevron-down"></i>'
    : 'Voir moins <i class="ti ti-chevron-up"></i>';
}
